import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

export interface UserData {
  isAuth: boolean
  token?: string
}

const initialState: UserData = {
  isAuth: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    userAuth(state, action: PayloadAction<UserData>) {
      const { isAuth, token } = action.payload
      state.isAuth = isAuth
      state.token = token
    },
  },
})

export const { userAuth } = userSlice.actions

export const selectUser = (state: RootState) => state.user
export const selectIsAuth = (state: RootState) => state.user.isAuth

export const userSliceReducer = userSlice.reducer
